import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=15da4bb1&scoped=true&"
import script from "./VCheckbox.vue?vue&type=script&lang=ts&"
export * from "./VCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./VCheckbox.vue?vue&type=style&index=0&id=15da4bb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da4bb1",
  null
  
)

export default component.exports